import type { RankTrackerEmptyState } from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/types";

export const getEmptyState = (hasProjects: boolean, hasTopics: boolean, isScraping: boolean): RankTrackerEmptyState => {
    if (!hasProjects) {
        return "noProject";
    }

    if (!hasTopics) {
        return "noTopics";
    }

    if (isScraping) {
        return "scraping";
    }

    return "noRankTracker";
};
